import { RangeSlider as MantineRangeSlider } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "../slider/slider.module.scss";
import type { CustomRangeSliderFactory, IProps } from "./range-slider.types";

/**
 * Range slider component for selecting a range of values.
 * @returns {JSX.Element} The RangeSlider component.
 */
const RangeSlider = componentWrapper<CustomRangeSliderFactory, IProps>("Slider", (props, ref) => {
    return (
        <MantineRangeSlider
            ref={ref}
            classNames={{
                root: styles["root"],
                label: styles["label"],
                thumb: styles["thumb"],
                trackContainer: styles["track-container"],
                track: styles["track"],
                bar: styles["bar"],
                markWrapper: styles["mark-wrapper"],
                mark: styles["mark"],
                markLabel: styles["mark-label"],
            }}
            {...props}
        />
    );
});

export { RangeSlider };
